import { useParams } from 'react-router-dom';
import cctvData from '../data/cctvData';
import CCTVPlayer from '../components/CCTVPlayer';

const CCTVPlayerPage = () => {
  const { gps } = useParams();
  const formattedGps = gps.replace('-', ','); // Convert back to original format

  const cam = cctvData.find(c => c.gps.replace(/\s*/g, '') === formattedGps.replace(/\s*/g, ''));

  if (!cam) return <h2>ไม่พบกล้อง</h2>;

  return <CCTVPlayer url={cam.url} />;
};

export default CCTVPlayerPage;
